import { stubFalse } from 'lodash';
import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { isSponsoredCampaign } from 'services/campaignDimension';
import { isAdminNetworkAccountType, isSponsoredAccount } from '../../../../../../account-management';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import { AVERAGE_CPC, CONVERSIONS, CVR, SITE_ID } from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import { siteReportColumnDefinition } from './columnDefinitions';
import { siteReportFooterColumnDefinition } from './footerColumnDefinitions';
import { graphConfigs } from './graph';
import { performanceColumns, customColumns, defaultColumns } from './reportPresets';
import { SITE_REALTIME_REPORT_ID } from './siteRealtimeReportId';

export const siteRealtimeReportConfig = {
    id: SITE_REALTIME_REPORT_ID,
    label: 'Sites',
    permissions: [REPORT_PERMISSION.CAMPAIGN_SUMMARY_BY_SITE, 'TA_REALTIME_SITE_REPORT'],
    visibilityCondition: ({ dimension, isRealtime, selectedAccount }) =>
        isSponsoredCampaign(dimension) &&
        isSponsoredAccount(selectedAccount?.partnerTypes) &&
        isRealtime &&
        !isAdminNetworkAccountType(selectedAccount?.type),
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-realtime-report-by-site',
    graph: graphConfigs,
    rowIdField: SITE_ID.field,
    columnsDef: siteReportColumnDefinition,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
        [REPORT_PRESET.PERFORMANCE]: { columns: performanceColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: siteReportFooterColumnDefinition,
    inlineEditPermissions: ['CAMPAIGN_EDIT'],
    rowHeight: 42,
    sortMap: {
        [CVR.field]: 'cpaConversionRate',
        [AVERAGE_CPC.field]: 'cpc',
        [CONVERSIONS.field]: 'cpaActionsNum',
    },
    customRestrictedFilters: {},
    filters: [
        {
            id: FILTER_TYPE.PLATFORM,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
        {
            id: FILTER_TYPE.COUNTRY,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
        {
            id: FILTER_TYPE.SITE_ID,
            multiSelect: true,
            minVisibleCount: 4,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
            // This is made to hide temporary this filter
            visibilityCondition: stubFalse,
        },
    ],
};
